import PropTypes from 'prop-types';


export const vehicleShape = PropTypes.shape({
  vehicleId: PropTypes.number.isRequired,
  regNumber: PropTypes.string.isRequired,
  lastOdoReading: PropTypes.number.isRequired,
  lastOdoReadingDate: PropTypes.string.isRequired,
  modelTypeCode: PropTypes.number.isRequired,
  vehicleDiagramCode: PropTypes.number.isRequired,
});

export const inspectionShape = PropTypes.shape({
  inspectionCode: PropTypes.number.isRequired,
  inspectionDateTime: PropTypes.string.isRequired,
  vehicle: vehicleShape.isRequired,
  inspectionRef: PropTypes.string,
  customerEmail: PropTypes.string,
});

/**
 * Splits the input array into 2 arrays based on the filter function.
 * Returns an array containing 2 children arrays.
 * The first array contains the truthy values. The second array contains the falsey values.
 *
 * @param {object[]} array An array to split into 2.
 * @param {func} filterFunc A function which returns a boolean value.
 */
export function biFilter(array, filterFunc) {
  return array.reduce(([aList, bList], item) => (
    filterFunc(item)
      ? [[...aList, item], [...bList]]
      : [[...aList], [...bList, item]]),
  [[], []]);
}

// Epoch (Java Instant) To Date
export function convertEpochToDate(epoch) {
  let milli = 0;
  if (epoch < 10000000000) {
    milli = epoch * 1000; // convert to milliseconds (epoch is expressed in seconds but JavaScript uses milliseconds)
  }
  milli += (new Date().getTimezoneOffset() * -1); // for timeZone
  return new Date(milli);
}
